import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import arrowUpSrc from '@cover/klimakrisestoppen/arrow-up.png';
import arrowDownSrc from '@cover/klimakrisestoppen/arrow-down.png';

const AnimatedLayer = styled.img`
	position: absolute;
`
const ArrowUpOne = styled(AnimatedLayer)`
	height: 19.5%;
	top: 1%;
	right: 20.5%;
`
const ArrowUpTwo = styled(AnimatedLayer)`
	height: 19.5%;
	top: 16%;
	right: 8.5%;
`
const ArrowUpThree = styled(AnimatedLayer)`
	height: 19.5%;
	top: 30.5%;
	right: 20.5%;
`

const ArrowDownOne = styled(AnimatedLayer)`
	height: 19.5%;
	top: 11.5%;
	left: 19.5%;
	z-index: 555;
`
const ArrowDownTwo = styled(AnimatedLayer)`
	height: 19.5%;
	top: 26%;
	left: 7.5%;
	z-index: 555;
`
const ArrowDownThree = styled(AnimatedLayer)`
	height: 19.5%;
	top: 40.5%;
	left: 19.5%;
	z-index: 555;
`

const KlimakriseStoppen = ({ play }) => {
	const arrowUpOne = useRef(false);
	const arrowUpTwo = useRef(false);
	const arrowUpThree = useRef(false);

	const arrowDownOne = useRef(false);
	const arrowDownTwo = useRef(false);
	const arrowDownThree = useRef(false);

	useEffect(() => {
		anime({
			targets: [arrowUpOne.current, arrowUpTwo.current, arrowUpThree.current],
			autoplay: play,
			loop: true,
			easing: 'linear',
			keyframes: [
				{translateY: '-260%', opacity: 1, duration: 1300},
				{translateY: '251%', opacity: 0, duration: 0},
				{translateY: '251%', opacity: 1, duration: 0},
				{translateY: '0%', opacity: 1, duration: 1300},
			]
		})
		anime({
			targets: [arrowDownOne.current, arrowDownTwo.current, arrowDownThree.current],
			autoplay: play,
			loop: true,
			easing: 'linear',
			keyframes: [
				{translateY: '260%', opacity: 1, duration: 1300},
				{translateY: '-300%', opacity: 0, duration: 0},
				{translateY: '-300%', opacity: 1, duration: 0},
				{translateY: '0%', opacity: 1, duration: 1300},
			]
		});
	}, [play])

	return (
		<>
			<ArrowUpOne src={arrowUpSrc} ref={arrowUpOne} />
			<ArrowUpTwo src={arrowUpSrc} ref={arrowUpTwo} />
			<ArrowUpThree src={arrowUpSrc} ref={arrowUpThree} />
			<ArrowDownOne src={arrowDownSrc} ref={arrowDownOne} />
			<ArrowDownTwo src={arrowDownSrc} ref={arrowDownTwo} />
			<ArrowDownThree src={arrowDownSrc} ref={arrowDownThree} />
		</>
	)
};

export default KlimakriseStoppen;